import React, { useContext } from 'react'
import { AppContext } from 'contexts/AppProvider'
import { useTranslation } from 'react-i18next'
import useModalServiceError, { MODAL_TYPE } from 'hooks/useModalServiceError'
import { clearLocalStorage } from 'helpers/localStorage'
import ModalWithImage from './ModalWithImage'

const clockIcon = '/assets/generic/modal/clock.svg'
const warningImage = '/assets/generic/modal/warning.png'
const fpErrorImage = 'assets/food-passion/icon-modal-handle-error-network.png'

const ModalServiceErrors = () => {
  const { t } = useTranslation()
  const { isHatoHeart, isFoodPassion } = useContext(AppContext)
  const { modalType, errorOperationType, resetModal } = useModalServiceError({ isHatoHeart, isFoodPassion })

  function onCloseModalSessionExpired() {
    resetModal()
    clearLocalStorage({ exceptKeys: ['private_cart'] })
    window.location.reload()
  }

  function handleCloseModalSystemError() {
    resetModal()
    if (errorOperationType === 'query') {
      setTimeout(() => {
        window.location.reload()
      }, 2000)
    }
  }

  return (
    <>
      <ModalWithImage
        isOpen={modalType === MODAL_TYPE.API_RATE_LIMIT}
        isLoading={false}
        onRequestClose={resetModal}
        imagePath={warningImage}
        isGenerateSrc
        imageSize="100px"
        title={t('modalAPIRateLimitTitle')}
        md
      />

      <ModalWithImage
        isOpen={modalType === MODAL_TYPE.SESSION_EXPIRED}
        isLoading={false}
        onRequestClose={onCloseModalSessionExpired}
        hideCloseButton
        imagePath={clockIcon}
        imageSize="120px"
        title={t('warningSessionExpTitle')}
        description={t('warningSessionExpDesc')}
        buttonText={t('continueOrdering')}
        md
      />

      <ModalWithImage
        isOpen={modalType === MODAL_TYPE.SYSTEM_PROCESSING}
        isLoading={false}
        onRequestClose={resetModal}
        imagePath={clockIcon}
        imageSize="120px"
        title={t('warningProcessingTitle')}
        description={t('warningProcessingDescirption')}
        buttonText={t('btnOK')}
        md
      />

      <ModalWithImage
        isOpen={modalType === MODAL_TYPE.HATO_HEART_SYSTEM_ERROR}
        isLoading={false}
        onRequestClose={handleCloseModalSystemError}
        imagePath={warningImage}
        isGenerateSrc
        imageSize="100px"
        title={t('messageDefaultSystemErrorTitle')}
        description={t('messageDefaultSystemErrorDes')}
        md
      />

      <ModalWithImage
        isOpen={modalType === MODAL_TYPE.FOOD_PASSION_SYSTEM_ERROR}
        isLoading={false}
        onRequestClose={handleCloseModalSystemError}
        imagePath={fpErrorImage}
        isGenerateSrc
        imageSize="120px"
        title={t('messageDefaultSystemErrorTitle')}
        description={t('messageDefaultSystemErrorDes')}
        md
      />

      <ModalWithImage
        isOpen={modalType === MODAL_TYPE.GENERIC_SYSTEM_ERROR}
        isLoading={false}
        onRequestClose={handleCloseModalSystemError}
        imagePath={warningImage}
        isGenerateSrc
        imageSize="100px"
        title={t('messageGenericDefaultSystemErrorTitle')}
        description={t('messageGenericDefaultSystemErrorDes')}
        md
      />
    </>
  )
}

export default ModalServiceErrors
